const Scroller = {
  init: () => {
    // initial scroll y position
    let prevScrollY = window.scrollY;

    // target the main header
    const header = document.querySelector(".header");

    // add initial sticky class if window is already scrolled
    if (prevScrollY > 120) {
      if (header) header.classList.add("header--has-scrolled");
    }

    window.onscroll = () => {
      // update current scroll y position
      let currentScrollY = window.scrollY;
      //console.log(prevScrollY);

      // header position and height calc (for default state: non sticky headers)
      //let headerTotal = header ? header.offsetTop + header.offsetHeight : 0;
      let headerTotal = 120;

      // console.log(`header.offsetTop: ${header.offsetTop}`);
      // console.log(`header.offsetHeight: ${header.offsetHeight}`);
      // console.log(`headerTotal: ${headerTotal}`);

      if (header) {
        // scrolling upwards or has scrolled within headerTotal
        if (prevScrollY > currentScrollY || currentScrollY < headerTotal) {
          // restore header
          header.classList.remove("header--has-scrolled");
        } else {
          // modify header
          header.classList.add("header--has-scrolled");
        }

        // check if we shall restore header
        if (currentScrollY < headerTotal) {
          header.classList.remove("header--has-scrolled");
        }
      }

      // update prev scroll y position
      prevScrollY = currentScrollY;
    };
  },
};

export default Scroller;
